<template>
    <div id="informator" v-show="show">
        <p><i class="green ti-check"></i><br/>Успешно</p>
    </div>
</template>

<script>
    export default {
        name: 'informator',
        props: {
            show: { required: true },
            type: { default: 'success' }
        }

    }
</script>

<style lang="scss">
    #informator {
        background: rgba(255,255,255,0.9);
        position: absolute;
        width: 100vw;
        height: 100vh;
        z-index: 1000;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
            font-size: 5rem;
            border: 1px limegreen solid;
            color: limegreen;
            padding: 1rem;
            margin-bottom: 1rem;
            border-radius: 5rem;
            display: inline-block;
        }
        p {
            font-size: 1.6rem;
            text-align: center;
            color: limegreen;
        }
    }
</style>


// WEBPACK FOOTER //
// Informator.vue?282ecb60